import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import _ from 'lodash'
import './style/index.less'
import 'ant-design-vue/dist/antd.css'
import './filter/index'
import { getToken , getSecret} from '@/utils/'
import VueClipboard from 'vue-clipboard2'
import Antd from 'ant-design-vue'
import Icon from 'vue-svg-icon/Icon.vue'
// 引入echarts
import echarts from 'echarts'
import 'echarts/map/js/world'
import md5 from 'js-md5'

Vue.component('icon', Icon)
Vue.use(VueClipboard)
Vue.use(Antd)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts


// 全局注册组件
import './utils/registerComponents'

const whiteList = ['/login', '/register']
store.commit('SET_INSTALL', false)
router.beforeEach((to, from, next) => {
  if (!spider.hasLogin) {
    if (!store.state.installed) {
      //生成菜单
      store.dispatch('GenerateRoutes').then((accessRoutes) => {
        store.commit('SET_INSTALL', true)
        setTimeout(() => {
          router.addRoutes(accessRoutes)
        }, 10)
        next()
      })
    }
    next()
  } else {
    if (getToken() && getSecret()) {
      // 判断是否有token
      if (to.path === '/login') {
        next({ path: '/' })
      } else {
        if (!store.state.installed) {
          //生成菜单
          store.dispatch('GenerateRoutes').then((accessRoutes) => {
            store.commit('SET_INSTALL', true)
            setTimeout(() => {
              router.addRoutes(accessRoutes)
            }, 10)
            next()
          })
        }
        next()
      }
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        // 在免登录白名单，直接进入
        next()
      } else {
        next('/login') // 否则全部重定向到登录页
      }
    }
  }
})

import vuescroll from 'vuescroll' //引入vuescroll
import 'vuescroll/dist/vuescroll.css' //引入vuescroll样式
Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      mode: 'native', //模式:pc native 移动端是slice
      sizeStrategy: 'percent', //父元素是否是固定的是就percent
      detectResize: true //内容是否根据页面调整
    },
    scrollPanel: {
      initialScrollY: false, //初始化距离顶部的位置
      initialScrollX: false, //初始化距离左侧的位置
      scrollingX: false, // 是否开启横向滚动
      scrollingY: true, //是否开启竖向滚动
      speed: 600, //多长时间内完成一次滚动。 数值越小滚动的速度越快。
      easing: 'easeInQuad', //默认动画
      verticalNativeBarPos: 'right',
      maxHeight: undefined, //这是滚动条最大高度,内容高度小于 maxHeight 时高度自适应，超出的话出现滚动条。
      maxWidth: undefined //这是滚动条最大宽度,内容宽度小于 maxWidth 时高度自适应，超出的话出现滚动条。
    },
    rail: {
      background: 'transparent', //轨道的背景色。
      opacity: 0.5, //轨道的透明度。 0是透明，1是不透明
      size: '4px', //轨道的尺寸。
      specifyBorderRadius: true, //是否指定轨道的 borderRadius， 如果不那么将会自动设置。
      gutterOfEnds: null,
      gutterOfSide: '0px', //距离容器的距离
      keepShow: false //是否即使 bar 不存在的情况下也保持显示。
    },
    bar: {
      showDelay: 500, //在鼠标离开容器后多长时间隐藏滚动条。
      onlyShowBarOnScroll: true, //是否只在滚动时显示 bar。
      keepShow: false, //滚动条是否保持显示。
      background: '#A2A2A3', //滚动条背景色。
      opacity: 1, //滚动条透明度。
      hoverStyle: false,
      specifyBorderRadius: true, //是否指定滚动条的 borderRadius， 如果不那么和轨道的保持一致。
      minSize: false, //为 bar 设置一个最小尺寸, 从 0 到 1. 如 0.3, 代表 30%.
      size: '4px', //bar 的尺寸。
      disable: false //是否禁用滚动条。
    }
  },
  name: 'vue-scroll'
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
